import { ISetting } from '@/api';

export const getSettingValue = (settings: undefined | ISetting[], settingName: string) => {
  if (!settings?.length) {
    return undefined;
  }

  return settings.find(o => o.name === settingName)?.value;
}